import { ErrorHandler, Injectable } from '@angular/core';

import { Logger} from "../logger";


@Injectable()
/**
 * @whatItDoes 
 * 
 * Handles errors in the application in a generic way. 
 *
 * @description
 *
 * The default implementation of `ErrorHandler` prints error messages to the `console`. To
 * intercept error handling, write a custom exception handler that replaces this default as
 * appropriate for your app.
 *
 * ### Example
 *
 * ```
 * public class MathClass{
 * 		constructor(private _UnhandledErrorHandler: UnhandledErrorHandler) { }
 * 
 * 		public Divide(numerator : number, denominator : number) {
 * 			try {
 * 				return numerator/denominator; 
 * 			}
 * 			catch (error) {
 * 				this._UnhandledErrorHandler.handleError(error); 
 * 			}
 * 		}
 * }
 * ```
 *
 * @stable
 */
export class UnhandledErrorHandler implements ErrorHandler {

// #region [ Constructor ]

	/**
	 * Constructor. 
	 * 
	 * @param messageService The PrimeNG message service. 
	 */
	constructor() {}

// #region [ Public Methods ]

	/**
	 * Handles any type of error in the application. 
	 * 
	 * @param error The error generated. 
	 * see also: Angular's ErrorHandler class.
	*/
	public handleError(error: any): void {
		Logger.Log(error);
	}

}